import React, { useContext, useEffect, useRef } from 'react';
import { GlobalContext } from '../../App.tsx';
import Menu from "./Menu/Menu.tsx";
import Files from "./Files/Files.tsx";
import MiddleComponent from "./MiddleComponent/MiddleComponent.tsx";
import NewChatButton from "../MenuPanel/NewChatButton/NewChatButton.tsx";
import {useAppStore} from "../../GlobalStore/GlobalStore.ts";
import SignIn from "./MiddleComponent/SignIn/SignIn.tsx";
import {getBlurStyles} from "../../Utils/misc/cssStyleUtils.ts";
import QuickSettings from "./QuickSettings/QuickSettings.tsx";

interface TopProps {
    isPreview: boolean;
}

const Top: React.FC<TopProps> = ({ isPreview }) => {
    const { menuRef } = useContext(GlobalContext);

    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { isMenuOpen } = dynamicStateObj;
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    // Needed for small screens to prevent closing the panel when the panels clicked
    const buttonRef = useRef<any>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node) &&
                buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
                setDynamicStateObj({isMenuOpen: false});
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isMenuOpen]);

    const getEnvironmentSpecificContent = () => {
        if (isPreview) {
            return (
                <>
                    <div className={`absolute left-1/2 transform -translate-x-1/2 ${isMenuOpen ? "opacity-30" : ""}`}>
                        <SignIn signInMessage={"Sign in to Continue"} />
                    </div>
                </>
            )
        } else if (environment.includes("jetbrains")) {
            return (
                <>
                    <Files />
                    <div className={`absolute left-1/2 transform -translate-x-1/2 ${isMenuOpen ? "opacity-30" : ""}`}>
                        <MiddleComponent />
                    </div>
                    <div className={"flex ml-auto mr-3 space-x-5"}>
                        <QuickSettings />
                        <NewChatButton />
                        <Menu buttonRef={buttonRef} />
                    </div>
                </>
            );
        } else if (environment === "vscode") {
            return (
                <>
                    <div className={"flex space-x-3"}>
                        <Menu buttonRef={buttonRef} />
                        <QuickSettings />
                        <NewChatButton />
                    </div>
                    <div className={`absolute left-1/2 transform -translate-x-1/2 ${isMenuOpen ? "opacity-30" : ""}`}>
                        <MiddleComponent />
                    </div>
                    <Files />
                </>
            );
        } else if (environment === "chrome") {
            // Chrome layout: NewChatButton on left, center component in middle, settings+menu on right
            // NewChatButton has its own ml-4 margin, so container only needs mr-auto for positioning
            return (
                <>
                    <div className={"flex mr-auto"}>
                        <NewChatButton />
                    </div>
                    <div className={`absolute left-1/2 transform -translate-x-1/2 ${isMenuOpen ? "opacity-30" : ""}`}>
                        <MiddleComponent />
                    </div>
                    <div className={"flex ml-auto mr-5 space-x-5"}>
                        <QuickSettings />
                        <Menu buttonRef={buttonRef} />
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div className={"flex"}>
                        <Menu buttonRef={buttonRef} />
                    </div>
                    <div className={`absolute left-1/2 transform -translate-x-1/2 ${isMenuOpen ? "opacity-30" : ""}`}>
                        <MiddleComponent />
                    </div>
                    <div className={"flex ml-auto mr-5 space-x-5"}>
                        <QuickSettings />
                        <NewChatButton />
                    </div>
                </>
            );
        }
    };
    const environmentSpecificContent = getEnvironmentSpecificContent();
    const blurStyles = getBlurStyles([dynamicStateObj.isMenuOpen, dynamicStateObj.isUploadOpen, dynamicStateObj.visiblePopup?.includes("settings")]);

    return (
        <div className={`z-20 top-0 left-0 right-0 h-8 flex items-center mt-2 ${blurStyles}`}>
            {environmentSpecificContent}
        </div>
    );
};

export default Top;